import styled from "styled-components";

const AppContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export default AppContainer;
